import React from "react";
import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Popover,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { lighten } from "@mui/material/styles";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import ManageAccountsTwoToneIcon from "@mui/icons-material/ManageAccountsTwoTone";

import { SignOut } from "src/handlers/Account";
import { getPresenceIdentity } from "src/handlers/Account/userAvatar";
import { clearActiveProject } from "src/handlers/Projects";

const MenuUserBox = styled(Box)(
  ({ theme }) => `
    background: ${theme.colors.alpha.black[5]};
    padding: ${theme.spacing(2)};
  `
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
    text-align: left;
    padding-left: ${theme.spacing(1)};
  `
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
    font-weight: ${theme.typography.fontWeightBold};
    color: ${lighten(theme.palette.secondary.main, 0.4)};
    display: block;
  `
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
    color: ${theme.palette.secondary.main};
  `
);

function HeaderUserbox({ onSignedOut }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [identity, setIdentity] = React.useState(() => getPresenceIdentity());
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    try {
      setIdentity(getPresenceIdentity());
    } finally {
      setLoading(false);
    }
  }, []);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    await SignOut();
    clearActiveProject();
    handleClose();
    setIdentity(getPresenceIdentity());

    if (onSignedOut) {
      onSignedOut();
    }
  };

  const isOpen = Boolean(anchorEl);

  if (loading) {
    return (
      <IconButton sx={{ ml: 2 }} color="primary" disabled>
        <Avatar {...getPresenceIdentity().avatarProps} />
      </IconButton>
    );
  }

  return (
    <>
      <IconButton
        sx={{ ml: 2 }}
        color="primary"
        aria-label="user menu"
        onClick={handleOpen}
      >
        <Avatar {...identity.avatarProps} />
      </IconButton>

      <Popover
        anchorEl={anchorEl}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuUserBox sx={{ minWidth: 210, display: "flex" }}>
          <Avatar {...identity.avatarProps} />
          <UserBoxText>
            <UserBoxLabel variant="body1">{identity.name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {identity.email}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>

        <Divider sx={{ mb: 0 }} />

        <List sx={{ p: 1 }} component="nav">
          <ListItemButton
            component="a"
            href="https://login.netbaseapp.com/if/user/#/settings"
            target="_blank"
            rel="noreferrer"
          >
            <ManageAccountsTwoToneIcon fontSize="small" />
            <ListItemText primary="Manage account" sx={{ ml: 1 }} />
          </ListItemButton>
        </List>

        <Divider />

        <Box sx={{ m: 1 }}>
          <Button color="primary" fullWidth onClick={handleSignOut}>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox; 
